var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.562 12.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6500;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.559.6a.645.645,0,0,0-.007-.069.34.34,0,0,0-.013-.058c0-.018-.011-.038-.017-.058A.278.278,0,0,0,16.5.355C16.489.336,16.479.32,16.47.3s-.026-.037-.039-.054-.012-.02-.019-.029S16.4.21,16.394.2s-.031-.03-.047-.046S16.317.133,16.3.12a.472.472,0,0,0-.053-.033L16.2.059A.458.458,0,0,0,16.14.037a.168.168,0,0,0-.057-.016.207.207,0,0,0-.059-.012A.284.284,0,0,0,15.958,0l-.024,0H.629L.605,0A.273.273,0,0,0,.541.009.194.194,0,0,0,.482.021.193.193,0,0,0,.423.037.4.4,0,0,0,.366.059C.348.068.332.078.314.085L.26.12C.246.133.231.146.217.157S.184.187.169.2L.151.219C.143.228.14.238.132.248S.107.282.094.3A.378.378,0,0,0,.067.355.278.278,0,0,0,.042.41C.035.43.029.45.024.468S.015.508.012.526A.667.667,0,0,0,0,.6C0,.6,0,.616,0,.627V11.573a.63.63,0,0,0,.629.63H15.934a.629.629,0,0,0,.628-.63V.627C16.562.616,16.559.6,16.559.6Zm-2.331.661L8.282,6.323,2.335,1.256ZM1.256,10.945V1.988l6.62,5.637a.614.614,0,0,0,.406.15.622.622,0,0,0,.407-.15l6.618-5.637v8.957Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d3e49e0afa9fc43bdd0f3b4864daf88e.svg";
export { ForwardRef as ReactComponent };